import { render, staticRenderFns } from "./EndorsementFormNote.vue?vue&type=template&id=56349ad4&scoped=true&"
import script from "./EndorsementFormNote.vue?vue&type=script&lang=ts&"
export * from "./EndorsementFormNote.vue?vue&type=script&lang=ts&"
import style0 from "./EndorsementFormNote.vue?vue&type=style&index=0&id=56349ad4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56349ad4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
